import React from 'react';
import { createRootRoute, Outlet } from '@tanstack/react-router';

/** The login site has no app frame: no top bar and no account menu, only the current screen. */
export function RootLayout() {
  return <Outlet />;
}

export const Route = createRootRoute({ component: RootLayout });
